module.exports = __webpack_public_path__ + "img/individ-fon-mob.b1578758.png";